import { assignStyle as untypedAssignStyle } from 'css-in-js-utils';
import { pipe, reduce } from 'ramda';
import felaPluginExtend from 'fela-plugin-extend';
import { makeResponsiveValuePlugin } from './plugins/responsiveValues';
import { makeTypedSelectorsPlugin } from './plugins/typedSelectors';
import { makeMultipleSelectorsPlugin } from './plugins/multipleSelectors';

import { NativeStyleObject, StyleObject } from './types';

const applyExtendPlugin = felaPluginExtend() as <T>(styleObject: T) => T;
const applyMultipleSelectorsPlugin = makeMultipleSelectorsPlugin() as <T>(styleObject: T) => T;
const applyResponsiveValuePlugin = makeResponsiveValuePlugin() as <T>(styleObject: T) => T;
const applyTypedSelectorsPlugin = makeTypedSelectorsPlugin() as <T>(styleObject: T) => T;

const applyPlugins = pipe(
	applyTypedSelectorsPlugin,
	applyResponsiveValuePlugin,
	applyMultipleSelectorsPlugin,
	applyExtendPlugin
);
const applyNativePlugins = applyExtendPlugin;

const assignStyle: (...styleObjects: StyleObject[]) => StyleObject = untypedAssignStyle as any;

export const mergeStyleObjects = (styleObjects: StyleObject[]): StyleObject =>
	styleObjects.length === 1
		? applyPlugins(styleObjects[0])
		: assignStyle({}, ...styleObjects.map(applyPlugins));

export const mergeNativeStyleObjects = (styleObjects: NativeStyleObject[]): NativeStyleObject =>
	styleObjects.length === 1
		? applyNativePlugins(styleObjects[0])
		: reduce(Object.assign, {}, styleObjects.map(applyNativePlugins));
